import styled from '@emotion/styled';
import React from 'react';
import { useAdministrationStateContext } from '../components/state';

const Content = styled.div`
    overflow-y: scroll;
    height: 80%;
    margin: 0.5rem;
`

const Error = styled.div`
    margin: 0.5rem;
    padding: 0.5rem;
    white-space: pre-wrap;
`

export function ErrorDisplay(){
    const { globalState: state } = useAdministrationStateContext();

    return (
        <Content>
            {state.errors.map((error) => 
                <div>
                    <Error>
                        {error.message}
                    </Error>
                    <Error>
                        {error.stacktrace}
                    </Error>
                </div>
            )}
        </Content>
  );
}